import CertificateComponent from './CertificateComponent';

export default CertificateComponent;
